import { utils } from '../../utils/utils';

const COMPONENT_NAME = 'timeline';

const TIMELINE_DEFAULTS = {};

function Timeline(element, settings) {
  this.element = $(element);
  this.settings = utils.mergeSettings(this.element[0], settings, TIMELINE_DEFAULTS);
  this.id = utils.uniqueId(this.element[0], COMPONENT_NAME);
  this.init();
}

Timeline.prototype = {

  init() {
    this.cacheElements();
    this.handleEvents();
    this.updateHeight();
  },

  cacheElements() {
    if (!this.element[0]) return;

    this.timeline = this.element[0];
    this.indicatorContainers = this.timeline.querySelectorAll('.indicator-container');
    this.indicators = this.timeline.querySelectorAll('.indicator');
  },

  updateHeight() {
    if (!this.element || !this.indicatorContainers || this.indicatorContainers.length === 0) return;

    const lastIndicatorContainer = this.indicatorContainers[this.indicatorContainers.length - 1];
    const lastIndicator = this.indicators[this.indicators.length - 1];

    if (lastIndicatorContainer && lastIndicator) {
      const indicatorRect = lastIndicator.getBoundingClientRect();
      const timelineRect = this.timeline.getBoundingClientRect();
      const height = (indicatorRect.top - timelineRect.top) + (indicatorRect.height / 2);
      this.timeline.style.setProperty('--timeline-height', `${height}px`);
    }
  },

  handleEvents() {
    const self = this;

    $(window).on(`resize.${COMPONENT_NAME}-${this.id}`, () => {
      self.updateHeight();
    });

    $('body').on(`afteropen.${COMPONENT_NAME}-${this.id}`, '.modal', function () {
      if ($(this).find(self.element).length) {
        self.updateHeight();
      }
    });

    if (window.MutationObserver) {
      this.observer = new MutationObserver((mutations) => {
        const hasStructuralChange = mutations.some(m => m.type === 'childList' && (m.addedNodes.length > 0 || m.removedNodes.length > 0));
        if (hasStructuralChange) {
          self.cacheElements();
        }
        self.updateHeight();
      });
      this.observer.observe(this.timeline, { childList: true, subtree: true });
    }
  },

  updated(settings) {
    if (settings) {
      this.settings = utils.mergeSettings(this.element[0], settings, this.settings);
    }
    this.updateHeight();
    return this;
  },

  destroy() {
    $(window).off(`resize.${COMPONENT_NAME}-${this.id}`);
    $('body').off(`afteropen.${COMPONENT_NAME}-${this.id}`);
    if (this.observer) {
      this.observer.disconnect();
    }
    $.removeData(this.element[0], COMPONENT_NAME);
  }
};

export { Timeline, COMPONENT_NAME };
